import React, { useState, useRef } from 'react'

import { Icon2, InputText, Popup } from '@elamajs/ui-kit'

import * as Styled from './SelectWithSearch.styled'

type Value = string | number

type Option = {
  label: string
  value: Value
}

type Props = {
  placeholder?: string
  value?: Value
  disabled?: boolean
  options?: Array<Option>
  onChange: (value: Value, label: string) => void
  label: string
}

const SelectWithSearch: React.FC<Props> = ({
  placeholder = 'Выберите',
  value,
  options,
  disabled,
  label,
  onChange
}) => {
  const labelRef = useRef<HTMLLabelElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const [searchValue, setSearchValue] = useState('')

  const handleToggleSelect = () => {
    if (!disabled) {
      setIsOpen(isOpen => !isOpen)
    }
  }

  const handlePopupVisibilityChange = (isVisible: boolean, e: Event) => {
    if (e.target === labelRef.current && !isVisible) return

    setIsOpen(isVisible)
  }

  const handleOptionChange = (value: Value) => {
    setIsOpen(false)
    onChange(value, label)
  }

  const handleSearch = (value: string) => setSearchValue(value)

  const filteredOptions = options?.filter(option =>
    option.label.toLowerCase().includes(searchValue.toLowerCase())
  )

  const selectedOptionLabel = options?.find(option => option.value == value)?.label
  const isSelected = !!value

  return (
    <Styled.Container>
      <Styled.Label
        ref={labelRef}
        isSelected={isSelected}
        isOpen={isOpen}
        disabled={disabled}
        onClick={handleToggleSelect}
      >
        <span>{selectedOptionLabel ?? placeholder} </span>
        <Icon2 icon="arrowDown" size="s" />
      </Styled.Label>
      <Styled.Popup
        as={Popup}
        anchor={labelRef}
        offset={[0, 5] as any}
        width="100%"
        maxHeight={290}
        isOpened={isOpen}
        onOpenedChange={handlePopupVisibilityChange}
      >
        <Styled.SearchInput
          as={InputText}
          placeholder="Поиск"
          width="100%"
          type="search"
          iconLeft={<Styled.SearchIcon as={Icon2} icon="magnifier" color="#A3ABC2" />}
          value={searchValue}
          onChange={handleSearch}
        />
        <Styled.OptionList role="listbox">
          {filteredOptions?.map(({ label, value }) => (
            <Styled.Option key={value} role="option" onClick={() => handleOptionChange(value)}>
              {label ?? value}
            </Styled.Option>
          ))}
        </Styled.OptionList>
      </Styled.Popup>
    </Styled.Container>
  )
}

export default SelectWithSearch
